import axios from 'axios';
import { AdresseIP } from './AdresseIp';

/*
 * Paramétrage du paiement du loyer, par cité.
 * Base : /campus-faso/parametre-paiement-cite
 *
 * Objet manipulé :
 * {
 *   idParametrePaiementCite   : number,
 *   idCite                    : number,
 *   nomCite                   : string,  // renvoyé par le back, non envoyé
 *   dureeOccupationMois       : number,  // durée totale d'occupation, en mois
 *   cautionMois               : number,  // caution, exprimée en mois de loyer
 *   loyerPremierVersementMois : number,  // mois de loyer payés au 1er versement
 *   resteAPayerMois           : number,  // calculé serveur, ne pas envoyer
 *   nombreEcheancesReste      : number,  // en combien de tranches le reste est dû
 *   idAnnee                   : number,  // année académique : le paramétrage vaut
 *                                        // pour une année donnée
 *   dateDebutOccupation       : string   // "dd-MM-yyyy", optionnel : sert au calcul
 *                                        // des dates limites de chaque échéance
 * }
 *
 * resteAPayerMois = dureeOccupationMois - loyerPremierVersementMois.
 * Le montant mensuel vient de CategorieChambre.montantChambre, pas d'ici.
 */
export class ParametrePaiementService {

    constructor(){
        this.adresse = new AdresseIP()
        this.url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement-cite'
    }

    /*
     * idAnnee : le paramétrage est propre à une année académique.
     * Tant que le back ne filtre pas, le paramètre est simplement ignoré et
     * l'écran filtre côté client.
     */
    getAll(idAnnee) {
        return axios.get(this.url + (idAnnee ? '?idAnnee='+idAnnee : ''))
                    .then(res => res.data);
    }
    /* Remplissage du modal pour une cité. 404 si la cité n'est pas encore paramétrée. */
    getParametreCite(idCite, idAnnee) {
        return axios.get(this.url+'/cite/'+idCite + (idAnnee ? '?idAnnee='+idAnnee : ''))
                    .then(res => res.data)
    }
    /* 409 si un paramètre actif existe déjà pour la cité : basculer alors en update(). */
    create(newParametrePaiement) {
        return axios.post(this.url, newParametrePaiement)
                    .then(res => res.data);
    }
    update(idParametrePaiementCite, newParametrePaiement) {
        return axios.put(this.url+'/'+idParametrePaiementCite, newParametrePaiement)
                    .then(res => res.data);
    }
    delete(idParametrePaiementCite) {
        return axios.patch(this.url+'/'+idParametrePaiementCite)
                    .then(res => res.data)
    }
    /*
     * Échéancier complet de la cité : une ligne par échéance, une colonne par
     * catégorie de chambre. 404 si la cité n'a pas de paramètre de paiement actif.
     */
    getEcheancierCite(idCite) {
        return axios.get(this.url+'/cite/'+idCite+'/echeancier-cite')
                    .then(res => res.data)
    }
    /*
     * Dates limites saisies à la main pour les échéances de la cité.
     *
     * ATTENTION : endpoint à faire implémenter côté back (404 aujourd'hui).
     * Il suppose que le serveur STOCKE ces dates sur le paramètre de la cité et
     * les reprenne telles quelles à la génération des échéanciers, au lieu de les
     * recalculer depuis dateDebutOccupation.
     *
     * Corps attendu : [ { "ordre": 1, "dateLimite": "01-10-2026" }, ... ]
     * Les dates sont portées par l'échéance, pas par la catégorie de chambre.
     */
    updateDatesLimites(idParametrePaiementCite, datesLimites) {
        return axios.put(this.url+'/'+idParametrePaiementCite+'/dates-limites', datesLimites)
                    .then(res => res.data)
    }
    /* Aperçu des échéances calculées par le serveur, sans rien enregistrer. */
    getApercuEcheancier(idCite, idCategorieChambre) {
        return axios.get(this.url+'/cite/'+idCite+'/echeancier?idCategorieChambre='+idCategorieChambre)
                    .then(res => res.data)
    }

}
